import { api, type ContentLanguage } from '@setplex/tria-api'
import { createStore } from 'effector'
import { LANGUAGE_ALL } from '~/shared/constants'
import { resetContentOnPreferredRegionChange } from './events'

export const getContentLanguagesFx = api.content.base.getContentLanguagesFx

export const $languages = createStore<ContentLanguage[]>([]) //
  .on(getContentLanguagesFx.doneData, (_, got) => {
    return [LANGUAGE_ALL, ...(got ?? [])]
  })
  .reset(resetContentOnPreferredRegionChange)
